import { useCallback, useEffect, useRef, useState } from 'react';

const useContainerWithScrollArrow = () => {
  const containerRef = useRef<HTMLDivElement>();
  const [showScrollButton, setShowScrollButton] = useState(false);

  const handleScroll = useCallback(() => {
    const containerElement = containerRef.current;
    if (!containerElement) return;

    const isAtBottom =
      containerElement.scrollHeight - containerElement.scrollTop <=
      containerElement.clientHeight + 100; // 100px threshold (don't show the arrow if there's less than 100px to scroll)
    setShowScrollButton(!isAtBottom);
  }, [containerRef]);

  const scrollToBottom = useCallback(() => {
    const containerElement = containerRef.current;
    containerElement?.scrollTo({ top: containerElement.scrollHeight, behavior: 'smooth' });
  }, [containerRef]);

  useEffect(() => {
    const containerElement = containerRef.current;
    if (containerElement) {
      containerElement.addEventListener('scroll', handleScroll);
      handleScroll();
      return () => containerElement.removeEventListener('scroll', handleScroll);
    }
  }, [handleScroll, containerRef]);

  return { showScrollButton, scrollToBottom, containerRef };
};

export default useContainerWithScrollArrow;
